import { useI18nStore } from "@/stores/i18nStore";
import {
  SubscriptionPlan,
  useSubscriptionStore,
} from "@/stores/subscriptionStore";
import { Lock } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";

interface SubscriptionGateProps {
  requiredPlan: SubscriptionPlan;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

const planHierarchy: Record<SubscriptionPlan, number> = {
  FREE: 0,
  PLUS: 1,
  PREMIUM: 2,
};

export const SubscriptionGate: React.FC<SubscriptionGateProps> = ({
  requiredPlan,
  children,
  fallback,
}) => {
  const { currentSubscription } = useSubscriptionStore();
  const { t } = useI18nStore();
  const navigate = useNavigate();

  const currentPlan = currentSubscription?.tier ?? "FREE";
  const hasAccess = planHierarchy[currentPlan] >= planHierarchy[requiredPlan];

  if (hasAccess) return <>{children}</>;

  if (fallback) return <>{fallback}</>;

  const label =
    requiredPlan === "PREMIUM"
      ? t.featureRequiresPREMIUM
      : t.featureRequiresPLUS;

  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-xl border-2 border-dashed border-gray-200 bg-gray-50 p-8 text-center">
      <Lock className="h-8 w-8 text-gray-400" />
      <p className="text-sm font-medium text-gray-600">{label}</p>
      <button
        onClick={() => navigate("/traveler/subscription")}
        className="inline-flex items-center rounded-lg bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-700 transition-colors"
      >
        {t.upgradeToUnlock}
      </button>
    </div>
  );
};
